import React from 'react';

const IMG_HERO = 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?q=80&w=2653&auto=format&fit=crop';

const ContactHero: React.FC = () => (
  <section className="relative min-h-screen flex items-center overflow-hidden">
    <img src={IMG_HERO} alt="Hospital Facility Corridor" className="absolute inset-0 w-full h-full object-cover opacity-40 mix-blend-overlay" />
    <div className="absolute inset-0 bg-primary/90" />

    <div className="container-main relative z-10 text-center w-full">
      <span className="inline-block bg-white/10 border border-white/20 text-white/80 text-xs uppercase tracking-widest font-semibold px-4 py-1.5 rounded-full mb-4 mt-20 md:mt-0">Reach Out</span>
      <h1 className="text-5xl md:text-6xl font-extrabold text-white mt-3 mb-5">Contact Us</h1>
      <p className="text-white/70 text-xl max-w-xl mx-auto">
        Schedule an estimate. Request a quote. Let's work together.
      </p>
    </div>
  </section>
);

export default ContactHero;
